import type { FieldError } from '../../types';

/** Shape of errors thrown by dataProvider (HttpError with the response body). */
export interface ApiError {
  message?: string;
  body?: { error?: string; message?: string; fields?: FieldError[] };
}

export const apiErrorMessage = (error: unknown, fallback = 'Ошибка') => {
  const e = error as ApiError | undefined;
  return e?.body?.fields?.[0]?.message || e?.body?.error || e?.message || fallback;
};
